import { TableContainer as _TableContainer, styled, Typography } from '@mui/material'

export const ListTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  maxWidth: 600,
  marginTop: theme.spacing(2),
}))

export const DemonstrationList = styled('ul')(() => ({
  maxWidth: 600,
}))

export const TableContainer = styled(_TableContainer)(({ theme }) => ({
  maxWidth: 600,
  padding: theme.spacing(2),
  paddingTop: 0,
}))

export const DemonstrationAudio = styled('audio')(() => ({
  height: 20,
  maxWidth: '100%',
}))
